export class PaymentOption {
    public imgPath: string;
    public instrumentNumber: string;
    public paymentMethod: string;
    public paymentText: string;
    public sportsOnly: boolean;
    public bankAccountsOnly: boolean;
    public ESIntensiveGreyOut: boolean;
    public isESRiskPlayer: boolean;
    public BANK_INSTRUMENT_LIST?: BANKS_LIST[];
    public userMaxFailDepStatus?: {
        expiryTime?: number;
        blocked?: boolean;
        blockEndDate?: string;
        blockEndTime?: string;
    };
    public es_pre_emptive_threshold_limit?: string;
    public es_threshold_limit?: string;
    public es_deposited_amount?: string;
    public es_allowed_amount?: string;
    public es_jumio_verification_url?: string;
}
export interface PaymentOptionInfo {
    imgPath: string;
    instrumentNumber: string;
    paymentMethod: string;
    paymentText: string;
    sportsOnly: boolean;
    bankAccountsOnly: boolean;
    isESRiskPlayer: boolean;
    ESIntensiveGreyOut: boolean;
    userMaxFailDepStatus: {
        expiryTime?: number;
        blocked?: boolean;
        blockEndDate?: string;
        blockEndTime?: string;
    };
}
export class BANKS_LIST {
    accountNumber: string;
    bankCode: string;
    bankName: string;
    branchCode: string;
}

export interface DepositRedirectInfo {
    submitCreq: boolean;
    submitJwt: boolean;
    creq: string;
    redirectionUrl: string;
    openInCustomTab: boolean;
    new_3ds2_route: boolean;
    redirectType: string;
    [key: string]: any;
}
